import generalMiddleware, {
  axiosInstanceWithBase,
} from "./middleware/middleware";
import { Response } from "./middleware/format-response";
import axios from "axios";

export const createInterviewVideoBlob = (
  data: any
): Promise<Response<string>> =>
  generalMiddleware.request({
    url: "/InterviewVideo",
    method: "POST",
    data: data,
  });
export const storeTimeStampApi = (data: any): Promise<Response<string>> =>
  generalMiddleware.request({
    url: "/QuestionResponse/UpdateQuestionTimeStamp",
    method: "PUT",
    data: data,
  });

export const saveEachQuestionAnswer = (data: any): Promise<Response<string>> =>
  generalMiddleware.request({
    url: "/QuestionResponse/CreateQuestionResponse",
    method: "POST",
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
export const submitInterview = (id: any): Promise<Response<string>> =>
  generalMiddleware.request({
    url: `/QuestionResponse/RateQuestionResponse?fk_CampaignLine_Id=${id}`,
    method: "POST",
  });

export const uploadVideoChunk = async (file: File, filename: string) => {
  const formData = new FormData();
  formData.append("file", file, filename);

  const uploadBaseUrl =
    process.env.FUNCTION_URL ??
    "https://tironemvideofileupload-gzcfajabamhcgybs.australiaeast-01.azurewebsites.net";

  const uploadBaseCode =
    process.env.FUNCTION_CODE ??
    "FSIwMrvzfXgIlDsDPXQDby4QQ53jLqWwK_nC1ImRWafCAzFuBhqAjw==";

  return axios.post(
    `${uploadBaseUrl}/api/UploadFileFunction?code=${uploadBaseCode}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

